var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "fill-height max-width pa-0 ma-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        {
          staticClass: "mb-2",
          staticStyle: { height: "32px" },
          attrs: { dense: "", "no-gutters": "" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "text-center pa-0 align-center d-flex justify-start",
              attrs: { md: "12" },
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "text-capitalize text-button text--secondary",
                  attrs: { color: "transparent" },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("label_system_date_YMDLabel", {
                          year: _vm.$getDateTime(_vm.startTime, "YYYY"),
                          month: _vm.$getDateTime(_vm.startTime, "MM"),
                          day: _vm.$getDateTime(_vm.startTime, "DD"),
                        }) +
                          " - " +
                          _vm.$t("label_system_date_YMDLabel", {
                            year: _vm.$getDateTime(_vm.endTime, "YYYY"),
                            month: _vm.$getDateTime(_vm.endTime, "MM"),
                            day: _vm.$getDateTime(_vm.endTime, "DD"),
                          })
                      )
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        {
          staticClass: "pb-0",
          staticStyle: {
            "border-bottom": "1px solid var(--main-border-color)",
            height: "50px",
          },
          attrs: { "no-gutters": "", dense: "" },
        },
        _vm._l(_vm.cycleType + 1, function (n) {
          return _c(
            "v-col",
            {
              key: n + "col",
              staticClass: "text-center fill-height pa-0 align-center",
              style: {
                borderRight:
                  n == 1 ? "1px solid var(--main-border-color)" : "none",
              },
              attrs: { cols: n === 1 ? 2 : undefined },
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "pa-0 fill-height align-end align-items-end",
                  attrs: { elevation: 0, tile: "" },
                },
                [
                  n === 1 && false
                    ? [
                        _c("DateSelect", {
                          attrs: {
                            startTime: _vm.startTime,
                            endTime: _vm.endTime,
                          },
                        }),
                      ]
                    : [
                        _c(
                          "div",
                          {
                            staticClass:
                              "fill-height max-width d-flex justify-end flex-column",
                          },
                          [
                            _c("DaySelect", {
                              attrs: { time: _vm.curPageDate[n - 2] },
                            }),
                          ],
                          1
                        ),
                      ],
                ],
                2
              ),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "v-container",
        {
          staticClass: "max-width pa-0 ma-0",
          style: {
            overflow: "overlay",
            height:
              _vm.$vuetify.breakpoint.height -
              460 +
              46 -
              (_vm.approval ? 82 : 0) +
              "px",
          },
          attrs: { fluid: "" },
        },
        [
          _vm.RosterList.length == 0 ? _c("noContent") : _vm._e(),
          _vm._l(_vm.RosterList, function (tr, index) {
            return _c(
              "v-row",
              {
                key: index + "roster",
                staticClass: "max-width flex-wrap",
                staticStyle: { height: "100px" },
                attrs: { dense: "", "no-gutters": "" },
              },
              _vm._l(_vm.cycleType + 1, function (n) {
                return _c(
                  "v-col",
                  {
                    key: n + "col",
                    staticClass:
                      "text-center max-width fill-height align-center",
                    style: {
                      borderRight:
                        n == 1 ? "1px solid var(--main-border-color)" : "none",
                    },
                    attrs: { cols: n === 1 ? 2 : undefined },
                  },
                  [
                    _c("shiftCard", {
                      attrs: {
                        col: n,
                        iSEdited: _vm.iSEdited,
                        roster_uuid: _vm.Roster_uuid,
                        curType: _vm.cycleType,
                        curData: tr,
                        shiftList: _vm.shiftList,
                        curDate: _vm.curPageDate[n - 2],
                      },
                      on: { onShift: _vm.toShift },
                    }),
                  ],
                  1
                )
              }),
              1
            )
          }),
        ],
        2
      ),
      _c(
        "v-row",
        {
          staticStyle: {
            height: "40px",
            "border-top": "1px solid var(--main-border-color)",
          },
          attrs: { dense: "", "no-gutters": "", justify: "start" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "text-center fill-height pa-0 pt-1 align-center",
              attrs: { cols: 2 },
            },
            [
              _c("TypeSelect", {
                attrs: { cycletype: _vm.cycleType, allDay: _vm.allDay },
                on: {
                  change: function (type) {
                    _vm.cycleType = type
                    _vm.page = 1
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "text-center fill-height pa-0 align-center",
              attrs: { cols: 8 },
            },
            [
              _c("v-pagination", {
                staticClass: "text--primary",
                attrs: {
                  color: "grey lighten-2 ",
                  length: Math.ceil(_vm.totalDay / Number(_vm.cycleType)),
                  "total-visible": 10,
                },
                model: {
                  value: _vm.page,
                  callback: function ($$v) {
                    _vm.page = $$v
                  },
                  expression: "page",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("RosterShiftDialog2", {
        attrs: {
          show: _vm.showRosterShift,
          curUuid: _vm.Roster_uuid,
          curData: _vm.curData,
        },
        on: {
          close: function ($event) {
            _vm.showRosterShift = false
            _vm.curData = null
          },
          onChange: _vm.controlNav,
          onSubmit: function ($event) {
            _vm.showRosterShift = false
            _vm.curData = null
            _vm.getRosterList()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }